import { fetchAlreadyValidatedProperties } from './private/utils';
export const isPropertyProvidedByRaasMetadataStore = objectTypeId => {
  return fetchAlreadyValidatedProperties().then(validatedProperties => {
    return validatedProperties.includes(objectTypeId);
  });
};